import angular from 'angular';
import 'angular-clipboard';
import { ShareMovePreviewConfig } from './preview.config';
import { ShareMovePreviewComponent } from './preview.component';
import {
  UCloudinaryImageDirectives,
  GoogleMapModule,
  RelevantContentComponent,
  StepPageModule,
} from '../../../common/directives';

export const ShareMovePreviewModule = angular
  .module('app.steps.share-move.preview', [
    'angular-clipboard',
    UCloudinaryImageDirectives.name,
    GoogleMapModule.name,
    RelevantContentComponent.name,
    StepPageModule.name,
  ])
  .config(ShareMovePreviewConfig)
  .component('updShareMovePreview', ShareMovePreviewComponent);
